export function ignoreUnavailableAction(): void {
  // Intentionally silent until the corresponding feature is implemented.
}
